
import { ref } from "vue";
import zhCn from "element-plus/lib/locale/lang/zh-cn";
import { Options, Vue } from "vue-class-component";
import { compare, dateConversion, getLocalProject } from "@/utils";
import * as echarts from "echarts";
import {
  dispatchDeepMemoryDeviceOptions,
  dispatchDeepMemorySceneOptions,
  dispatchDeepMemoryTrend,
  dispatchDeepMemoryDateOptions,
  dispatchDeepMemorySubSceneOptions,
  dispatchDeepMemoryRecordList,
  dispatchDeepMemoryCircleChart,
  dispatchDeepMemoryData,
  dispatchDeepFind,
  dispatchRecentTaskrecord,
  dispatchDeepMemoryReport,
  dispatchSendMemory,
  dispatchDeepUnityMemoryReport,
  dispatchDeepUnityMemoryList,
} from "@/store/performance/actions";

import { store } from "@/store";
import {
  readGetDeepMemorySceneOption,
  readGetDeepMemoryDeviceOption,
  readGetDeepMemoryTrend,
  readGetDeepMemorySubsceneOption,
  readGetDeepMemoryDateOption,
  readGetDeepMemoryRecondList,
  readGetDeepMemoryCircleChart,
  readGetDeepMemoryData,
  readDeepFind,
  readRecentTaskrecord,
  readGetDeepMemoryReport,
  readGetDeepUnityMemoryReport,
  readGetDeepUnityMemoryList,
} from "@/store/performance/getters"; //引入仓库接口
import { dispatchGetDeviceSpecs } from "@/store/device/actions";
import { readDeviceSpecs } from "@/store/device/getters";
import { readUserProfile } from "@/store/main/getters";
import { readMyProjects, readProjectScenes } from "@/store/project/getters";
import { dispatchGetProjectScenes } from "@/store/project/actions";
import { ElMessage } from "element-plus";
import { dispatchGetSimpleScripts } from "@/store/task/actions";
import { readSimpleScriptList } from "@/store/task/getters";
import { color } from "html2canvas/dist/types/css/types/color";
import { number, version } from "echarts/core";

export default class ProjectOverview extends Vue {
  public localProject = Number(getLocalProject());
  public taskId = "";
  public dateVersion = "";
  public loading = false;
  public currentPage = 1;
  public size = 10;
  public serch_input = "";
  public sortNum = 0;
  public async onSearch() {
    this.allTableLoading = true;
    this.currentPage = 1;
    await dispatchDeepUnityMemoryList(store, {
      project: this.localProject,
      old_test:
        this.memoryTableData.old_test == null
          ? ""
          : this.memoryTableData.old_test,
      id_test: this.memoryTableData.id_test,
      page: this.currentPage,
      size: this.size,
      search: this.serch_input,
      reverse: this.sortNum,
    });
    this.allTableLoading = false;
  }
  public company(item) {
    if (Math.abs(item) < 1024) {
      return item + "B";
    }
    if (Math.abs(item) >= 1024 && Math.abs(item) < 1024 * 1024) {
      return (item / 1024).toFixed(2) + "K";
    }
    if (Math.abs(item) >= 1024 * 1024 && Math.abs(item) < 1024 * 1024 * 1024) {
      return (item / 1024 / 1024).toFixed(2) + "M";
    }
  }
  public allTableLoading = false;
  public async sort_change(column) {
    this.allTableLoading = true;
    if (column.order == null) {
      this.sortNum = 0;
    }
    if (column.order === "descending") {
      this.sortNum = 0;
    }
    if (column.order == "ascending") {
      this.sortNum = 1;
    }
    await dispatchDeepUnityMemoryList(store, {
      project: this.localProject,
      old_test:
        this.memoryTableData.old_test == null
          ? ""
          : this.memoryTableData.old_test,
      id_test: this.memoryTableData.id_test,
      page: this.currentPage,
      size: this.size,
      search: this.serch_input,
      reverse: this.sortNum,
    });
    this.allTableLoading = false;
  }
  public async handleCurrentChange() {
    this.allTableLoading = true;
    await dispatchDeepUnityMemoryList(store, {
      project: this.localProject,
      old_test:
        this.memoryTableData.old_test == null
          ? ""
          : this.memoryTableData.old_test,
      id_test: this.memoryTableData.id_test,
      page: this.currentPage,
      size: this.size,
      search: this.serch_input,
      reverse: this.sortNum,
    });
    this.allTableLoading = false;
  }
  public async mounted() {
    this.loading = true;
    await dispatchRecentTaskrecord(store, {
      project: this.localProject,
      is_memory: 1,
    });
    this.taskId = readRecentTaskrecord(store)[0].value;
    await dispatchDeepMemoryDateOptions(store, {
      project: this.localProject,
    });
    if (readGetDeepMemoryDateOption(store)?.length == 1) {
      this.dateVersion = readGetDeepMemoryDateOption(store)[0];
    } else {
      this.dateVersion = readGetDeepMemoryDateOption(store)[1];
    }

    await dispatchDeepUnityMemoryReport(store, {
      project: this.localProject,
      task_record_id: Number(this.taskId),
      version: this.dateVersion,
    });
    await dispatchDeepUnityMemoryList(store, {
      project: this.localProject,
      old_test:
        this.memoryTableData.old_test == null
          ? ""
          : this.memoryTableData.old_test,
      id_test: this.memoryTableData.id_test,
      page: this.currentPage,
      size: this.size,
      search: this.serch_input,
      reverse: this.sortNum,
    });
    this.resBase64 = [];
    await this.trendList?.forEach((v, index) => {
      this.drawTrend(v, index);
    });
    await this.memoryData();
    await this.memoryTable.forEach((v) => {
      this.getSpanArr(v.data);
    });
    await this.memoryTableAll;
    this.loading = false;
  }
  public deviationColor(item: any) {
    if (item) {
      // if (String(item).indexOf("+") != -1) {
      //   return "red";
      // }
      if (String(item).indexOf("-") != -1) {
        return "#00b050";
      } else {
        return "red";
      }
    }
  }
  public resBase64: any[] = []; // 趋势图存储
  public save_report(is_auto?: boolean) {
    let upload_data: any;

    upload_data = {
      project: this.localProject,
      file_list: this.resBase64,
      title: this.formMail.title,
      recv: this.formMail.addressee,
      cc: this.formMail.CC_List,
      send: this.formMail.Sender,
      task_record_id: Number(this.taskId),
      version: this.dateVersion,
      type: "unity",
    };
    dispatchSendMemory(store, upload_data);
    ElMessage({
      //Message 消息提示
      message: "报告发送中...",
      showClose: true,
    });
    this.edit = false;
  }
  public sizeCompany(item) {
    if (String(item) != "") {
      if (Number(item) < 1024) {
        return String(item) + "K";
      }
      if (Number(item) > 1024) {
        return (Number(item) / 1024).toFixed(1) + "M";
      }
    } else {
      return "";
    }
  }
  public deviation(item: any) {
    if (item) {
      if (Math.abs(Number(item)) < 1024) {
        // return "(" + String(item) + "K)";
        if (String(item).indexOf("-") != -1) {
          return "(" + String(item) + "K)";
        } else {
          return "(+" + String(item) + "K)";
        }
      }
      if (Math.abs(Number(item)) > 1024) {
        // return "(+" + String((Number(item) / 1024).toFixed(1)) + "M)";
        if (String(item).indexOf("-") != -1) {
          return "(" + String((Number(item) / 1024).toFixed(1)) + "M)";
        } else {
          return "(+" + String((Number(item) / 1024).toFixed(1)) + "M)";
        }
      }
    } else {
      return "";
    }
  }
  public get details_list() {
    let list: any = [];
    list = [
      { label: "名称", prop: "name" },
      { label: "类型", prop: "type" },
      // { label: "size", prop: "size" },
    ];

    return list;
  }
  public serch = "";
  public edit = false;
  public sendOut() {
    this.edit = !this.edit;
  }
  public async detailChange() {
    this.loading = true;
    this.serch_input = "";
    await dispatchRecentTaskrecord(store, {
      project: this.localProject,
      is_memory: 1,
    });
    await dispatchDeepMemoryDateOptions(store, {
      project: this.localProject,
    });
    if (readGetDeepMemoryDateOption(store)?.length == 1) {
      this.dateVersion = readGetDeepMemoryDateOption(store)[0];
    } else {
      this.dateVersion = readGetDeepMemoryDateOption(store)[1];
    }
    await dispatchDeepUnityMemoryReport(store, {
      project: this.localProject,
      task_record_id: Number(this.taskId),
      version: this.dateVersion,
    });
    await dispatchDeepUnityMemoryList(store, {
      project: this.localProject,
      old_test:
        this.memoryTableData.old_test == null
          ? ""
          : this.memoryTableData.old_test,
      id_test: this.memoryTableData.id_test,
      page: this.currentPage,
      size: this.size,
      search: "",
      reverse: this.sortNum,
    });
    this.resBase64 = [];
    await this.trendList.forEach((v, index) => {
      this.drawTrend(v, index);
    });
    await this.memoryData();
    this.spanArr = [];
    await this.memoryTable.forEach((v) => {
      this.getSpanArr(v.data);
    });
    await this.memoryTableAll;
    this.loading = false;
  }
  public drawTrend(item, i) {
    let ordinates: any[] = [];
    item.trend.scene_list.forEach((v, index) => {
      ordinates.push({
        name: v,
        type: "line",
        data: item.trend.memory[index],
        smooth: true, // 平滑曲线
        symbol: "circle", //拐点设置为实心
        itemStyle: {
          normal: {
            label: {
              // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
              show: true,
            },
          },
        },
      });
    });
    let performance_line: any = document.getElementById(
      "performance_line" + item.chinese
    );
    echarts.dispose(performance_line);
    let PerformanceLineChart = echarts.init(performance_line);
    let option;
    option = {
      title: {
        left: "center",
        textStyle: {
          fontSize: 16,
          fontWeight: "normal",
        },
      },
      tooltip: {
        trigger: "axis",
      },
      legend: {
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "20%",
        right: "4%",
        containLabel: true,
      },

      animation: false,
      series: ordinates,
      yAxis: {
        type: "value",
        axisLabel: {
          formatter: "{value}B",
        },
      },
      xAxis: {
        type: "category",
        data: item.trend.date_list,
      },
    };
    PerformanceLineChart.setOption(option);
    var res_base64 = PerformanceLineChart.getDataURL({
      excludeComponents: ["toolbox"],
    }); //拿到base64 地址，就好下载了。
    let res: any = {};
    res.file_base64 = res_base64;
    (res.chinese = item.chinese), (res.device_name = item.device_name);
    res.filename = "memoryReport" + i + ".png";
    this.resBase64.push(res);
  }
  public get RecentTaskrecord() {
    return readRecentTaskrecord(store);
  }
  public get dateOptions() {
    return readGetDeepMemoryDateOption(store);
  }
  public get memory_risk_list() {
    return readGetDeepUnityMemoryReport(store).memory_risk_list;
  }
  public newVersion = "";
  public oldVersion = "";
  public memoryData() {
    (this.newVersion = readGetDeepUnityMemoryReport(store).new_version),
      (this.oldVersion = readGetDeepUnityMemoryReport(store).old_version);
  }
  public get deepUnityMemoryList() {
    return readGetDeepUnityMemoryList(store);
  }
  public getNum(item1, item2, type) {
    if (item1 == "" || item2 == null) {
      return "--";
    }

    if (type === "risk") {
      if (item1 > item2) {
        return this.company(item1 - item2) + "↑";
      } else if (item1 < item2) {
        return this.company(item2 - item1) + "↓";
      }
      if (item1 === item2) {
        return "--";
      }
    } else if (type == "moudle") {
      if (item1 > item2) {
        return this.company(item1 - item2) + "↑";
      } else if (item1 < item2) {
        return this.company(item2 - item1) + "↓";
      }
      if (item1 === item2) {
        return "--";
      }
    }
  }
  public com_num_color(newItem, oldItem) {
    // if (item.indexOf("↑") != -1) {
    //   return "red";
    // } else if (item.indexOf("↓") != -1) {
    //   return "#00b050";
    // } else {
    //   return "#212529";
    // }
    if (newItem < oldItem) {
      return "#00b050";
    }
    if (oldItem == null) {
      return "#212529";
    } else {
      if (
        readGetDeepUnityMemoryReport(store)?.memory_settings.risk_rule
          .difference != ""
      ) {
        if (
          newItem - oldItem >
          Number(
            readGetDeepUnityMemoryReport(store)?.memory_settings.risk_rule
              .difference
          )
        ) {
          return "red";
        }
      } else {
        return "#212529";
      }
    }
  }
  public spanArr = [];
  public cellMerge({ row, column, rowIndex, columnIndex }) {
    if (columnIndex === 0) {
      const _row = this.spanArr[rowIndex];
      const _col = _row > 0 ? 1 : 0;

      return {
        rowspan: _row,
        colspan: _col,
      };
    }
  }
  public pos = 0;
  public getSpanArr(data) {
    for (var i = 0; i < data.length; i++) {
      if (i === 0) {
        this.spanArr.push(1);
        this.pos = 0;
      } else {
        // 判断当前元素与上一个元素是否相同
        if (data[i].name === data[i - 1].name) {
          this.spanArr[this.pos] += 1;
          this.spanArr.push(0);
        } else {
          this.spanArr.push(1);
          this.pos = i;
        }
      }
    }
  }
  public getRisk(newValue, oldValue, list) {
    let listAll = [];

    list.forEach((v, index) => {
      if (typeof oldValue[index] == "number") {
        if (
          (newValue[index] - oldValue[index]) / oldValue[index] >
          Number(
            readGetDeepUnityMemoryReport(store)?.memory_settings.risk_rule
              .percentage
          )
        ) {
          listAll.push(true);
        }
        if (
          newValue[index] - oldValue[index] >
          Number(
            readGetDeepUnityMemoryReport(store)?.memory_settings.risk_rule
              .difference
          )
        ) {
          listAll.push(true);
        }
      }
    });
    if (listAll.some((v) => v == true)) {
      return "高风险";
    } else {
      return "低风险";
    }
  }

  public get_risk_color(item) {
    if (item === "高风险") {
      return "red";
    } else {
      return "rgb(0, 176, 80)";
    }
  }
  public tdr_risk(item, tdr) {
    let tdrLevel = tdr.level;
    let params = tdr.type;
    let type = "";
    let riskList = readGetDeepUnityMemoryReport(store)?.memory_settings;
    if (params == 0) {
      type = "Android";
    } else {
      type = "iOS";
    }
    if (riskList.tdr_risk_rule[type]["level_" + tdrLevel] == "") {
      return "#606266";
    }
    if (item > riskList.tdr_risk_rule[type]["level_" + tdrLevel]) {
      return "red";
    } else {
      return "#606266";
    }
  }
  public leftAllTable = [];
  public get memoryTableAll() {
    this.leftAllTable = readGetDeepUnityMemoryReport(store).stack?.list;
    return this.leftAllTable;
  }
  public get memoryTableData() {
    return readGetDeepUnityMemoryReport(store).stack;
  }
  public get riskTable() {
    let list = [];
    readGetDeepUnityMemoryReport(store)?.memory_risk_list?.forEach(
      (v, index) => {
        list.push({
          scene: v.scene,
          data: [],
          deviceList: v.device_list,
          deviceLevel: v.device_item,
        });
        for (let i in v.sub_scene) {
          list[index].data.push({
            name: i,
            data: v.sub_scene[i],
          });
        }
      }
    );

    return list;
  }
  public async serchChange() {
    this.allTableLoading = true;
    this.currentPage = 1;
    await dispatchDeepUnityMemoryList(store, {
      project: this.localProject,
      old_test:
        this.memoryTableData.old_test == null
          ? ""
          : this.memoryTableData.old_test,
      id_test: this.memoryTableData.id_test,
      page: this.currentPage,
      size: this.size,
      search: this.serch_input,
      reverse: this.sortNum,
    });
    this.allTableLoading = false;
  }
  public formMail = {
    title: "", //标题
    Sender: "gamerobot@tencent.com", //发件人
    addressee: "", //收件人
    CC_List: "", //抄送人
  };
  public get memoryTable() {
    let list = [];
    readGetDeepUnityMemoryReport(store)?.memory_list?.forEach((v, index) => {
      list.push({
        scene: v.device_name + v.chinese,
        data: [],
        deviceList: v.sub_scenes,
        deviceLevel: v.device_item,
      });
      // for (let i in v.data) {
      //   list[index].data.push({
      //     name: i,
      //     label: v.data[i].label,
      //     data: v.data[i].data,
      //   });
      // }
      v.data.forEach((item, i) => {
        list[index].data.push({
          name: item[0].label,
          label: item[0].type,
          data: [],
        });
        v.sub_scenes.forEach((h, k) => {
          list[index].data[i].data.push({
            new: item[k].new,
            old: item[k].old,
          });
        });
      });
    });

    return list;
  }
  public get get_is_super() {
    let judge = true;
    let MyProject = readMyProjects(store).filter(
      (item: any) => item.project.id == this.localProject
    )[0]?.is_project_admin;
    if (readUserProfile(store)?.is_super) {
      judge = false;
    } else if (MyProject) {
      judge = false;
    } else {
      judge = true;
    }
    return judge;
  }
  public get trendList() {
    return readGetDeepUnityMemoryReport(store)?.trend_list;
  }
}
